module.exports = __webpack_public_path__ + "img/computational-sciences-heading.6755df49.png";